<script>
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import moment from "moment";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AddEdit from "./AddEdit.vue";
import StrPlanDetay from "./StrPlanDetay.vue";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import Vue from "vue";
export default {
  mixins: [Api, Sabit],
  page: {
    title: "Stratejik Plan Değerlendirme",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    StrPlanDetay,
    AddEdit,
    ckeditor: CKEditor.component,
    BirimSecimi
  },
  data() {
    return {
      title: this.$t("StrPlanDeger.Title"),
      items: [
        {
          text: this.$t("StrPlanDeger.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrPlanDeger.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrPlanDeger.Title"),
          active: true,
        },
      ],
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      Tarih: moment(new Date()).format('YYYY-MM-DD') ,
      ComboboxUstDonemler: [],
      ComboboxDonemler: [],
      ComboboxTablolar: [],
      Isbirlikciler: [],
      birimgostergeler: [],
      gostergeler: [],
      plandegerler: [],
      detaydegerler: [],
      AddEdit: "",
      DataUpdate: "",
      guncelle: 0,
      DonemAktif: false,
      BirimTipUni: false,
      tablodegerler: {
        Id: "",
        Deleted: false,
        Tabloid: "",
        Donemid: "",
        Sapmanedeni: "",
        Alinacakonlem: "",
        BirimId: ""
      },

      Filter: {
        DonemId: "",
        AltdonemId: "",
        TabloId: "",
        UpdateDetayId: "",
        BirimId: ""
      },
      editor: ClassicEditor,
      editorData: "",
      content: "<h1>Some initial content</h1>",

      plugins: ["advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker", "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking", "save table contextmenu directionality emoticons template paste textcolor"],
      toolbar: "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | l      ink image | print preview media fullpage | forecolor backcolor emoticons",
      options: {
        height: 300,
        style_formats: [{ title: "Bold text", inline: "b" }, { title: "Red text", inline: "span", styles: { color: "#ff0000" } }, { title: "Red header", block: "h1", styles: { color: "#ff0000" } }, { title: "Example 1", inline: "span", classes: "example1" }, { title: "Example 2", inline: "span", classes: "example2" }, { title: "Table styles" }, { title: "Table row 1", selector: "tr", classes: "tablerow1" }],
      },
    };
  },
  mounted() {
    setTimeout(() => {
      this.showModal = true;
    }, 1500);
  },
  methods: {
    onSubmit() { },

    Get() { },

    alt_donem_yukle(ust_donem_id) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.ComboboxDonemler = [];
      if (ust_donem_id != null && ust_donem_id != "") {
        let Filter = "&UstId=" + ust_donem_id + "&Approval=true&Asc=Sira" + "&VeriTipi=3";
        this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: Filter }).then((res) => {
          for (var i = 0; i < res.Data.length; i++) {

              this.ComboboxDonemler.push({ Id: res.Data[i].Id, Value: res.Data[i].Aciklama });

      
          }

        });
      }
    },
    donem_aktif_kontrol(Data){
      this.ActionsSingleGet({
                Service: "strperfdonem",
                Id: Data,
              }).then((res) => {
                  if ( this.$options.filters.formatDate(res.Data.BaslamaTarihi) <= this.Tarih && this.Tarih <= this.$options.filters.formatDate(res.Data.BitisTarihi)) {
                    this.DonemAktif = true;
                  }else{
                    this.DonemAktif = false;
                  }

              });

    },
    tablo_yukle(ust_donem_id, birimid) {
    if(this.Filter.BirimId != null && this.Filter.BirimId != ""){
                  this.ActionsSingleGet({
                Service: "OBirim",
                Id: this.Filter.BirimId,
              }).then((response) => {
                                     this.ActionsSingleGet({
                Service: "OBirimTip",
                Id: response.Data.BirimTipId,
              }).then((res) => {
                    if(res.Data.Birimtipadi == 'Üniversite'){
                      this.BirimTipUni = true;
                    }else{
                      this.BirimTipUni = false;
                    }
              });
              });
    
    }

      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.ComboboxTablolar = [];
      let tum_tablolar = [];

      this.ActionsFilterGet({ Service: "StrPerfTablo", Page: Page, Filter: "&DonemId=" + ust_donem_id + "&Asc=SiraNo" }).then((res) => {
        tum_tablolar = res.Data;

        if (birimid != "" && birimid != null) {
          let Page = {
            PageNumber: "1",
            PageSize: "9999",
          };

          let Filter = "&BirimId=" + birimid + "&DonemId=" + ust_donem_id;


          this.ActionsFilterGet({ Service: "StrBirimGosterge", Page: Page, Filter: Filter }).then((res) => {
            this.Isbirlikciler = res.Data;
            let tablo = [];
            if (this.Isbirlikciler.length > 0) {

              for (var s = 0; s < tum_tablolar.length; s++) {

                for (var i = 0; i < this.Isbirlikciler.length; i++) {

                  if (this.Isbirlikciler[i].Gostergeids.length > 0 && this.Isbirlikciler[i].Tabloid == tum_tablolar[s].Id && this.Isbirlikciler[i].GostergeHedefDonemlerindeKapaliMi == false) {
                    tablo.push(tum_tablolar[s]);
                  }


                }

              }
              this.ComboboxTablolar = tablo;

              if (this.ComboboxTablolar.length > 0) {

                this.YuklenenTablolar = this.ComboboxTablolar;


              } else {
                this.Message.position = "center";
                this.Message.icon = "warning";
                this.Message.title = this.$t('StrGostergeGirisi.Filtreleme.mesaj');
                this.Message.showConfirmButton = false;
                this.Message.timer = 1000;

                Vue.swal(this.Message);
              }



            } else {
              this.ComboboxTablolar = [];
            }

          });




        }

      });

    },
    yukle() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };

      if (this.Filter.TabloId != null && this.Filter.TabloId != "" && this.BirimTipUni == false) {
          this.ActionsFilterGet({ Service: "StrRaporlama/GetBirimHedefTutturmaOranlariTablosu", Page: Page, Filter: "&Tanimid=" + this.Filter.TabloId + "&Birimid=" + this.Filter.BirimId + "&Ustdonemid=" + this.Filter.DonemId + "&Donemid=" + this.Filter.AltdonemId}).then((resp) => {
            this.gostergeler = resp.Data[0].Detay;
              let filtrele = "&DonemId=" + this.Filter.AltdonemId + "&TabloId=" + this.Filter.TabloId + "&BirimId=" + this.Filter.BirimId;
            this.ActionsFilterGet({ Service: "StrPlanDeger", Page: Page, Filter: filtrele }).then((res) => {
              this.plandegerler = res.Data;
              this.detaydegerler = [];

              if (this.plandegerler.length > 0) {
                for (var i = 0; i < this.plandegerler.length; i++) {
                  if (this.plandegerler[i].Tabloid != null && this.plandegerler[i].Tabloid != "" && (this.plandegerler[i].Tablodetayid == null || this.plandegerler[i].Tablodetayid == "")) {
                    this.tablodegerler.Id = this.plandegerler[i].Id;
                    this.tablodegerler.Donemid = this.plandegerler[i].Donemid;
                    this.tablodegerler.BirimId = this.plandegerler[i].BirimId;
                    this.tablodegerler.Tabloid = this.plandegerler[i].Tabloid;
                    this.tablodegerler.Sapmanedeni = this.plandegerler[i].Sapmanedeni;
                    this.tablodegerler.Alinacakonlem = this.plandegerler[i].Alinacakonlem;
                  }

                  if (this.plandegerler[i].Tablodetayid != null || this.plandegerler[i].Tablodetayid != "") {
                    this.detaydegerler.push(this.plandegerler[i]);
                  }
                }
              } else {
                this.tablodegerler = {}
                this.tablodegerler.Id = "";
                this.tablodegerler.Donemid = this.Filter.AltdonemId;
                this.tablodegerler.Tabloid = this.Filter.TabloId;
                this.tablodegerler.BirimId = this.plandegerler[i].BirimId;
                this.tablodegerler.Sapmanedeni = "";
                this.tablodegerler.Alinacakonlem = "";
              }
            });
          });

      }
      if(this.BirimTipUni == true){
          this.ActionsFilterGet({ Service: "StrRaporlama/GetStratejikPlanDegerlendirmeFormu", Page: Page, Filter: "&isPerformansHedefi=true&isStrPlanDegerlendirme=true&Tabloid=" + this.Filter.TabloId + "&Donemid=" + this.Filter.AltdonemId}).then((resp) => {
            this.gostergeler = resp.Data.TabloDetay;
            if(resp.Data){

            let filtrele = "&DonemId=" + this.Filter.AltdonemId + "&TabloId=" + this.Filter.TabloId + "&BirimId=" + this.Filter.BirimId;
            this.ActionsFilterGet({ Service: "StrPlanDeger", Page: Page, Filter: filtrele }).then((res) => {
              this.plandegerler = res.Data;


              this.detaydegerler = [];

              if (this.plandegerler.length > 0) {
                for (var i = 0; i < this.plandegerler.length; i++) {
                  if (this.plandegerler[i].Tabloid != null && this.plandegerler[i].Tabloid != "" && (this.plandegerler[i].Tablodetayid == null || this.plandegerler[i].Tablodetayid == "")) {
                    this.tablodegerler.Id = this.plandegerler[i].Id;
                    this.tablodegerler.Donemid = this.plandegerler[i].Donemid;
                    this.tablodegerler.BirimId = this.plandegerler[i].BirimId;
                    this.tablodegerler.Tabloid = this.plandegerler[i].Tabloid;
                    this.tablodegerler.Sapmanedeni = this.plandegerler[i].Sapmanedeni;
                    this.tablodegerler.Alinacakonlem = this.plandegerler[i].Alinacakonlem;
                  }

                  if (this.plandegerler[i].Tablodetayid != null || this.plandegerler[i].Tablodetayid != "") {
                    this.detaydegerler.push(this.plandegerler[i]);
                  }
                }
              } else {
                                this.tablodegerler = {}
                this.tablodegerler.Id = "";
                this.tablodegerler.Donemid = this.Filter.AltdonemId;
                this.tablodegerler.Tabloid = this.Filter.TabloId;
                this.tablodegerler.BirimId = this.plandegerler[i].BirimId;
                this.tablodegerler.Sapmanedeni = "";
                this.tablodegerler.Alinacakonlem = "";
              }
            });

            }
              });
      }
      this.guncelle = this.guncelle + 1;
    },
    Yuzde(hedef, gerceklesme){
    let percentage = (gerceklesme/hedef) * 100;
    return percentage.toFixed(2);
          
    },
    tablokaydet() {
      if (this.tablodegerler.Id == null || this.tablodegerler.Id == "") {
        this.$delete(this.tablodegerler, "Id");
        this.tablodegerler.Donemid = this.Filter.AltdonemId;
        this.tablodegerler.Tabloid = this.Filter.TabloId;
        this.tablodegerler.BirimId = this.Filter.BirimId;

        this.Post("StrPlanDeger", this.tablodegerler).then((res) => {
          if (res) {
            this.yukle();
          }
        });
      } else {
        this.Update("StrPlanDeger", this.tablodegerler).then((res) => {
          if (res) {
            this.yukle();
          }
        });
      }
    },

    Secilmis_Idler(secilmis) {
      this.Filter.BirimId = secilmis;
    },
    ChangePage(DefaultPage) {
      if (DefaultPage) {
        this.Page.PageNumber = DefaultPage;
        this.Get();
      }
    },

    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
  },

  computed: {},

  created() {
    this.Get();

    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };

 

    let sorgu = "&Tip=1561";
    let Tip = [];

    this.ActionsFilterGet({ Service: "OKeyValues", Page: Page, Filter: sorgu }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        if (res.Data[i].Kod == 1 || res.Data[i].Kod == 2) {

          Tip.push(res.Data[i].Id);

        }

      }

      let altsorgu = "&UstIdDoluMu=false&Approval=true";

      let tipler = "";

      for (var s = 0; s < Tip.length; s++) {

        tipler = tipler + "&TipId=" + Tip[s];

      }

      altsorgu = altsorgu + tipler;



      this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: altsorgu }).then((res) => {
        for (var i = 0; i < res.Data.length; i++) {

          this.ComboboxUstDonemler.push(res.Data[i]);

        }
      });

    });

  },

  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    formatDateTable(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY");
      }
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />

      <div class="col-md-8">
        <table class="col-md-12">
          <tr>
            <td>
              <b-form-group class="mb-2" id="donemler" label="" label-for="text">
                <select v-model="Filter.DonemId" class="form-select" @change="alt_donem_yukle(Filter.DonemId)"
                  type="text">
                  <option value="">{{ this.$t("StrPlanDeger.Filtreleme.UstId") }}</option>
                  <option v-for="UstDonemVerileri in ComboboxUstDonemler" :key="UstDonemVerileri.Id"
                    :value="UstDonemVerileri.Id">
                    {{ UstDonemVerileri.Aciklama }}
                  </option>
                </select>
              </b-form-group>

              <b-form-group class="mb-2" id="altdonemler" label="" label-for="text">
                <select v-model="Filter.AltdonemId" class="form-select" type="text" @change="donem_aktif_kontrol(Filter.AltdonemId)">
                  <option value="">{{ this.$t("StrPlanDeger.Filtreleme.DonemId") }}</option>
                  <option v-for="DonemVerileri in ComboboxDonemler" :key="DonemVerileri.Id" :value="DonemVerileri.Id">
                    {{ DonemVerileri.Value }}
                  </option>
                </select>
              </b-form-group>


              <BirimSecimi :title="''" :title_class="'mb-1'" :closeOnSelect="true" :sutun="'0'" :multiple="false"
                :YetkiKontrol="1" :personel_id="null" :BirimTipId="null"
                @Secilmis_Idler="Secilmis_Idler($event), tablo_yukle(Filter.DonemId, Filter.BirimId)" />


              <b-form-group class="mb-2" id="tablolar" label="" label-for="text">
                <select v-model="Filter.TabloId" class="form-select" type="text">
                  <option value="">{{ this.$t("StrPlanDeger.Filtreleme.TabloId") }}</option>
                  <option v-for="Tablolar in ComboboxTablolar" :key="Tablolar.Id" :value="Tablolar.Id">
                    {{ Tablolar.Adi }}
                  </option>
                </select>
              </b-form-group>
            </td>
            <td valign="bottom">
              <div class="button-items">
                <button style="margin-left:20px; margin-bottom:20px" type="button" @click="yukle()"
                  class="btn btn-primary">
                  {{ this.$t("StrPlanDeger.Filtreleme.BtnYukle") }}
                </button>
              </div>
            </td>
          </tr>
        </table>
      </div>

      <hr />

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="row justify-content-center">
              <div class="col-xs-6 col-sm-6 col-md-6">
                <div class="card-body">
                  <h4 class="card-title">{{ this.$t("StrPlanDeger.AddEditUst.Sapmanedeni") }}</h4>
                  <!-- Editor -->
                  <ckeditor v-model="tablodegerler.Sapmanedeni" :editor="editor" :disabled="!DonemAktif"></ckeditor>
                </div>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6">
                <div class="card-body">
                  <h4 class="card-title">{{ this.$t("StrPlanDeger.AddEditUst.Alinacakonlem") }}</h4>
                  <!-- Editor -->
                  <ckeditor v-model="tablodegerler.Alinacakonlem" :editor="editor" :disabled="!DonemAktif"></ckeditor>
                </div>
              </div>
            </div>

            <div align="center" class="button-items" v-if="DonemAktif">
              <button type="button" @click="tablokaydet()" class="btn btn-primary">
                {{ this.$t("StrPlanDeger.AddEditUst.BtnKaydet") }}
              </button>
            </div>
            <br />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{ this.$t("StrPlanDeger.Table.Title") }}</h4>
            </div>
            <center>
              <div class="col-11">
                <div class="table-responsive">
                  <table class="table">
                    <thead class="table-light">
                      <tr>
                        <th></th>
                        <th>{{ this.$t("StrPlanDeger.Table.SiraNo") }}</th>
                        <th scope="col">{{ this.$t("StrPlanDeger.Table.Gosterge") }}</th>
                        <th scope="col" style="text-align: center;">{{ this.$t("StrPlanDeger.Table.Hedef") }}</th>
                        <th scope="col" style="text-align: center;">{{ this.$t("StrPlanDeger.Table.Gerceklesme") }}</th>
                        <th scope="col" style="text-align: center;">{{ this.$t("StrPlanDeger.Table.Oran") }}</th>

                        <th scope="col" style="width: 85px; text-align: center; vertical-align: middle;" v-if="DonemAktif">{{
                          this.$t("StrPlanDeger.Table.Islem") }}</th>
                      </tr>
                    </thead>
                    <tbody v-for="(Data,index) in gostergeler" :key="index">
                      <tr v-if="BirimTipUni!=true">
                        <th scope="row" class="custom-accordion">
                          <a class="text-body fw-medium py-1 d-flex align-items-center" data-toggle="collapse"
                            v-b-toggle="'CollapseAltTablo' + Data.Gosid" role="button" aria-expanded="false"
                            aria-controls="categories-collapse">
                            <i class="mdi mdi-chevron-up accor-down-icon ms-auto"></i>
                          </a>
                        </th>
                        <td>{{ Data.Sira }}</td>
                        <td>{{ Data.Gos }}</td>
                        <td style="text-align: center;">{{ Data.Hh }}</td>
                        <td style="text-align: center;">{{ Data.Gh }}</td>
                        <td  v-if="(Data.So < 50 || Data.So > 150) && !(Data.Hh == 0 && Data.Gh == 0)"
                                                    style="background-color:#ff4040; text-align: center;"><span style="color:wheat">{{ Data.So
                                                    }}</span></td>
                                                    <td  v-if="(Data.Hh == 0 && Data.Gh == 0)"
                                                    style="background-color:grey; text-align: center;"><span style="color:white">{{ Data.So
                                                    }}</span></td>
                                         <td  v-if="!(Data.So < 50 || Data.So > 150) && !(Data.Hh == 0 && Data.Gh == 0)"
                                                    style="background-color:#00a000;text-align: center;"><span style="color:wheat">{{ Data.So
                                                    }}</span></td>

                        <td style="width: 85px; text-align: center; vertical-align: middle;" v-if="DonemAktif">

                          <b-button-group>
                            <b-button variant="success" v-b-modal.degergiris @click="Filter.UpdateDetayId = Data.Gosid"><i
                                class="fas fa-pencil-alt"></i></b-button>
                          </b-button-group>
                        </td>
                      </tr>
                      <tr v-if="BirimTipUni!=true">
                        <td></td>
                        <td colspan="6">
                          <b-collapse class="collapse show" :id="'CollapseAltTablo' + Data.Gosid">
                            <StrPlanDetay :DonemId="Filter.AltdonemId" :TabloId="Filter.TabloId" :Tablodetayid="Data.Gosid"
                              :Guncelleme="guncelle" :BirimId="Filter.BirimId" />
                          </b-collapse>
                        </td>
                      </tr>
                      <tr v-if="BirimTipUni==true">
                        <th scope="row" class="custom-accordion">
                          <a class="text-body fw-medium py-1 d-flex align-items-center" data-toggle="collapse"
                            v-b-toggle="'CollapseAltTablo' + Data.tabloDetayID" role="button" aria-expanded="false"
                            aria-controls="categories-collapse">
                            <i class="mdi mdi-chevron-up accor-down-icon ms-auto"></i>
                          </a>
                        </th>
                        <td>{{ index + 1 }}</td>
                        <td>{{ Data.PerformanGostergesi }}</td>
                        <td style="text-align: center;">{{ Data.HedeflenenDeger }}</td>
                        <td style="text-align: center;">{{ Data.GerceklesenDeger }}</td>
                        <td  v-if="((Data.Performans < 50) || (Data.Performans > 150)) && !(Data.HedeflenenDeger == 0 && Data.GerceklesenDeger == 0)"
                                                    style="background-color:#ff4040; text-align: center;"><span style="color:wheat">{{ Data.Performans
                                                    }}</span></td>
                        <td  v-if="(Data.HedeflenenDeger == 0 && Data.GerceklesenDeger == 0)"
                                                    style="background-color:grey; text-align: center;"><span style="color:white">{{ Data.Performans }}</span></td>
                        <td  v-if="!((Data.Performans < 50) || (Data.Performans > 150)) && !(Data.HedeflenenDeger == 0 && Data.GerceklesenDeger == 0)"
                                                    style="background-color:#00a000;text-align: center;"><span style="color:wheat">{{ Data.Performans
                                                    }}</span></td>

                        <td style="width: 85px; text-align: center; vertical-align: middle;" v-if="DonemAktif">

                          <b-button-group>
                            <b-button variant="success" v-b-modal.degergiris @click="Filter.UpdateDetayId = Data.tabloDetayID"><i
                                class="fas fa-pencil-alt"></i></b-button>
                          </b-button-group>
                        </td>
                      </tr>
                      <tr v-if="BirimTipUni==true">
                        <td></td>
                        <td colspan="6">
                          <b-collapse class="collapse show" :id="'CollapseAltTablo' + Data.tabloDetayID">
                            <StrPlanDetay :DonemId="Filter.AltdonemId" :TabloId="Filter.TabloId" :Tablodetayid="Data.tabloDetayID"
                              :Guncelleme="guncelle" :BirimId="Filter.BirimId" />
                          </b-collapse>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </center>
            <br />
          </div>
        </div>
      </div>

      <AddEdit :DonemId="Filter.AltdonemId" :TabloId="Filter.TabloId" :Tablodetayid="Filter.UpdateDetayId"
        @TableUpdate="yukle" :BirimId="Filter.BirimId" />
    </Layout>
  </Loader>
</template>
